<template>
  <edit-modal
    :is-show-dialog="isShowDialog"
    :action-label="actionLabel"
    :title="dialogTitle"
    @on-close="onClose"
    @on-action="onAction"
  >
    <v-overlay
      :absolute="true"
      :value="isModalLoading"
    >
      <v-progress-circular indeterminate size="24"></v-progress-circular>
    </v-overlay>
    <v-form
      ref="form"
      autocomplete="off"
      method="post"
      action=""
      style="position:relative;"
    >
      <copy-button
        v-if="!isCreation"
        style="position:absolute; top: 0; right: 0;"
        @click="$emit('copy-item', editableObject)"
      />
      <input autocomplete="false" name="hidden" type="text" style="display:none;">
      <v-container>
        <v-row
          v-model="valid"
          :lazy-validation="true"
        >
          <v-col
            cols="12"
            sm="4"
            class="py-md-0"
          >
            <datetime-picker
              v-model="editableObject.datetime"
              prepend-icon="mdi-calendar-clock"
              :label="lang($store, 'sap/listings.global.filter.hints.datetime')"
              :rules="[rules.required]"
              locale="ru"
            />
          </v-col>
          <v-col
            cols="12"
            sm="4"
            class="py-md-0"
          >
            <v-select
              v-model="editableObject.order_complex_type"
              :items="orderComplexTypeItems"
              prepend-icon="mdi-format-list-bulleted-type"
              single-line
              :hint="lang($store, 'sap/listings.global.filter.hints.order_base_type')"
              persistent-hint
              :error-messages="(errors && errors.order_complex_type)?errors.order_complex_type:null"
              @change="removeError('order_complex_type')"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            class="py-md-0"
          >
            <v-select
              v-model="editableObject.order_status"
              :items="orderStatusItems"
              prepend-icon="mdi-cart-arrow-right"
              single-line
              :hint="lang($store, 'sap/listings.global.filter.hints.order_status')"
              persistent-hint
              :error-messages="(errors && errors.order_status)?errors.order_status:null"
              @change="removeError('order_status')"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="3"
            class="py-md-0"
          >
            <v-select
              v-model="editableObject.tracker"
              :items="trackerItems"
              single-line
              :hint="lang($store, 'sap/listings.global.filter.hints.tracker')"
              persistent-hint
              :error-messages="(errors && errors.tracker)?errors.tracker:null"
              @change="removeError('tracker')"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="3"
            class="py-md-0"
          >
            <v-list-item
              @click="editableObject.is_cleaner_ok = 1 - editableObject.is_cleaner_ok"
            >
              <v-list-item-action>
                <v-checkbox
                  v-model="editableObject.is_cleaner_ok"
                  color="yellow darken-2"
                  @click.prevent=""
                  :false-value="0"
                  :true-value="1"
                ></v-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>
                  {{ lang($store, 'sap/listings.global.filter.hints.is_cleaner_ok') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            class="py-md-0"
          >
            <v-list-item
              @click="editableObject.is_contact_ok = 1 - editableObject.is_contact_ok"
            >
              <v-list-item-action>
                <v-checkbox
                  v-model="editableObject.is_contact_ok"
                  color="yellow darken-2"
                  @click.prevent=""
                  :false-value="0"
                  :true-value="1"
                ></v-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>
                  {{ lang($store, 'sap/listings.global.filter.hints.is_contact_ok') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            class="py-md-0"
          >
            <div class="d-flex">
              <v-list-item
                @click="editableObject.is_payed = 1 - editableObject.is_payed"
              >
                <v-list-item-action>
                  <v-checkbox
                    v-model="editableObject.is_payed"
                    color="light-green darken-1"
                    @click.prevent=""
                    :false-value="0"
                    :true-value="1"
                  ></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ lang($store, 'sap/listings.global.filter.hints.is_payed') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                @click="editableObject.is_presence = 1 - editableObject.is_presence"
              >
                <v-list-item-action>
                  <v-checkbox
                    v-model="editableObject.is_presence"
                    color="light-green darken-1"
                    @click.prevent=""
                    :false-value="0"
                    :true-value="1"
                  ></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ lang($store, 'sap/listings.global.filter.hints.is_presence') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="py-md-0"
          >
            <address-selector
              :required="addressError"
              :disable-close="!isCreation"
              :selected-address="editableObject.address"
              @select="editableObject.address = $event"
            />
            <div>
              <v-text-field
                v-model="editableObject.minicomment"
                :counter="200"
                :rules="[rules.max(200)]"
                prepend-icon="mdi-tooltip-text-outline"
                :label="lang($store, 'sap/listings.global.filter.hints.minicomment')"
                autocomplete="off"
                :error-messages="(errors && errors.minicomment)?errors.minicomment:null"
                @input="removeError('minicomment')"
                class="pt-0"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                v-model="editableObject.minicomment2"
                :counter="200"
                :rules="[rules.max(200)]"
                prepend-icon="mdi-tooltip-text-outline"
                :label="lang($store, 'sap/listings.global.filter.hints.minicomment2')"
                autocomplete="off"
                :error-messages="(errors && errors.minicomment2)?errors.minicomment2:null"
                @input="removeError('minicomment2')"
                class="pt-0"
              ></v-text-field>
            </div>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="py-md-0"
          >
            <cleaner-selector
              :selected-cleaner="editableObject.foreman"
              @select="editableObject.foreman = $event"
              :role="FOREMAN"
              :label="lang($store, 'sap/listings.global.filter.hints.search_foreman')"
              :bg-color="'#efe8f0'"
            />
            <cleaners-selector
              :selected-cleaners="editableObject.cleaners"
              @updated="editableObject.cleaners = $event"
              :error-messages="(errors && errors.cleaners_uuid)?errors.cleaners_uuid:null"
              :role="CLEANER_COMPLEX"
              :dateTime="dateIso"
              :disabled="!editableObject.datetime"
              :hint="lang($store, 'sap/listings.global.filter.hints.search_cleaner_datetime')"
            />
            <div class="my-2 mt-16">
              <div>{{ lang($store, 'sap/listings.global.filter.hints.revenue') }}</div>
              <div class="pl-2 v-list v-sheet theme--light v-list--dense v-list--subheader v-list--two-line">
                <v-text-field
                  type="number"
                  v-model="editableObject.revenue"
                  :rules="[rules.int]"
                  prepend-icon="mdi-cash-100"
                  :label="$t('table.headers.sum')"
                  autocomplete="off"
                  :error-messages="(errors && errors.revenue)?errors.revenue:null"
                  @input="removeError('revenue')"
                ></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
            class="py-md-0"
          >
            <div>
              <v-select
                v-model="editableObject.source"
                :items="maybeWithoutExcluded"
                :background-color="SOURCES_COLORS[editableObject.source]
                ?SOURCES_COLORS[editableObject.source]
                :'white'"
                :item-color="SOURCES_COLORS[editableObject.source]
                ?SOURCES_COLORS[editableObject.source]
                 :'black'"
                class="invert-select"
                :class="editableObject.source"
                prepend-icon="mdi-arrow-decision-outline"
                single-line
                :hint="lang($store, 'sap/listings.global.filter.hints.source')"
                persistent-hint
                :error-messages="(errors && errors.source)?errors.source:null"
                @change="removeError('source')"
              ></v-select>
            </div>
            <div class="d-flex mt-4">
              <v-checkbox
                v-model="editableObject.is_manual_price"
                color="yellow darken-2"
                @click.prevent
                :false-value="0"
                :true-value="1"
              ></v-checkbox>
              <v-text-field
                v-model="editableObject.manual_price"
                :rules="[rules.int_or_null, rules.max(6)]"
                :label="lang($store, 'sap/listings.global.filter.hints.manual_price')"
                autocomplete="off"
                :disabled="!editableObject.is_manual_price"
                :error-messages="(errors && errors.manual_price)?errors.manual_price:null"
                @input="removeError('manual_price')"
              ></v-text-field>
            </div>
            <div>
              <v-text-field
                v-model="editableObject.note"
                :counter="200"
                :rules="[rules.max(200)]"
                prepend-icon="mdi-tooltip-text-outline"
                :label="lang($store, 'sap/listings.global.filter.hints.note')"
                autocomplete="off"
                :error-messages="(errors && errors.note)?errors.note:null"
                @input="removeError('note')"
              ></v-text-field>
            </div>
            <div>
              <v-textarea
                v-model="editableObject.additional_info"
                :counter="3000"
                :rules="[rules.max(3000)]"
                prepend-icon="mdi-account-badge-horizontal-outline"
                :label="lang($store, 'sap/listings.global.filter.hints.additional_info')"
                autocomplete="off"
                :error-messages="(errors && errors.additional_info)?errors.additional_info:null"
                @input="removeError('additional_info')"
              ></v-textarea>
            </div>
            <div>
              <v-text-field
                v-model="editableObject.promocode"
                :counter="50"
                :rules="[rules.max(50)]"
                prepend-icon="mdi-tooltip-text-outline"
                :label="lang($store, 'sap/listings.global.filter.hints.promocode')"
                autocomplete="off"
                :error-messages="(errors && errors.promocode)?errors.promocode:null"
                @input="removeError('promocode')"
              ></v-text-field>
              </div>
            <div>
              <v-textarea
                v-model="editableObject.contact_feedback"
                :counter="3000"
                :rules="[rules.max(3000)]"
                prepend-icon="mdi-account-badge-horizontal-outline"
                :label="lang($store, 'sap/listings.global.filter.hints.contact_feedback')"
                autocomplete="off"
                :error-messages="(errors && errors.contact_feedback)?errors.contact_feedback:null"
                @input="removeError('contact_feedback')"
              ></v-textarea>
            </div>
            <div v-if="isShowDialog">
              <div>
                <vue-dropzone
                  ref="dropzone"
                  id="orderAttachmentsUploader"
                  :options="dropOptionsDefault"
                  @vdropzone-complete="afterComplete"
                  @vdropzone-success="onFileUploaded"
                  @vdropzone-error="onFileError"
                ></vue-dropzone>
              </div>

              <div v-if="attachmentsFiles.length > 0" style="margin-bottom: 85px;">
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    sm="4"
                    class="py-md-0"
                    v-for="attachment in attachmentsFiles"
                    :key="attachment.id"
                  >
                    <div class="preview-attachment">
                      <a :href="attachment.link" target="_blank" class="preview-attachment__content">
                        <img v-if="isImage(attachment.link)" :src="attachment.link" :alt="attachment.link">
                        <div class="text" v-else>{{ attachment.link }}</div>
                      </a>
                      <v-btn
                        x-small fab dark falt fixed top absolute
                        right="right"
                        class="setting-fab"
                        color="red"
                        style="position: absolute; right: 0%; top: 0%;"
                        @click="deleteFile(attachment.id)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </div>

            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </edit-modal>
</template>

<script>
import VueDropzone from 'vue2-dropzone';

/* constants */
import { FOREMAN, CLEANER_COMPLEX } from '@/constants/roles';
import { ORDER } from '@/constants/trackers';
import moment from 'moment';
import * as orderComplexTypes from '../../constants/order_complex_types';
import * as orderStatuses from '../../constants/order_statuses';
import * as sources from '~constants/sources';
import { SOURCES_COLORS } from '../../constants/sources_data';
import { ORDERS_COMPLEX } from '../../constants/payable';
/* utils */
import {deepMerge, cloneObj, prepareValidationMessages} from '../../utils';
import AddressProxy from '@/proxies/Contact/AddressProxy';
import * as needAdditionalServicesTypes from '../../constants/need_additional_services_types';
/* mixins */
import editModalMixin from '@/mixins/editModalMixin';
import validationMixin from '@/mixins/validationMixin';
import orderComplexTypeFilter from '@/mixins/filters/orderComplexTypeFilter';
import orderStatusFilter from '@/mixins/filters/orderStatusFilter';
import trackerFilter from '@/mixins/filters/trackerFilter';
import sourcesFilter from '@/mixins/filters/sourcesFilter';
import needAdditionalServicesFilter from "@/mixins/filters/needAdditionalServicesFilter";
/* components */
import EditModal from './EditModal.vue';
import DatetimePicker from '../DatetimePicker.vue';
import AddressSelector from '../autocomples/AddressSelector.vue';
import CleanersSelector from '../autocomples/CleanersSelector.vue';
import CleanerSelector from '../autocomples/CleanerSelector.vue';
import CopyButton from '../minialerts/CopyButton.vue';
import OrderComplexProxy from "@/proxies/Order/OrderComplexProxy";
import i18n from '@/i18n';


export default {
  name: 'EditModalOrderComplex',
  mixins: [
    editModalMixin,
    validationMixin,
    needAdditionalServicesFilter,
    orderComplexTypeFilter,
    orderStatusFilter,
    trackerFilter,
    sourcesFilter,
  ],
  components: {
    EditModal,
    DatetimePicker,
    AddressSelector,
    CleanersSelector,
    CopyButton,
    CleanerSelector,
    VueDropzone,
  },
  props: {
    item: {
      type: Object,
      default: () => {
      },
    },
    errors: {
      type: Object,
      default: () => {
      },
    },
    subscription: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      SOURCES_COLORS,
      ORDERS_COMPLEX,
      FOREMAN,
      CLEANER_COMPLEX,
      orderComplexTypes,
      useNullableOrderComplexType: false,
      useNullableTracker: false,
      useNullableSource: false,
      /* validation */
      addressError: false,
      showPass: false,
      /* Data */
      initialEditableObject: {
        order_complex_type: orderComplexTypes.SPRING_CLEANING,
        order_status: orderStatuses.ORDERED,
        source: sources.UNSET,
        tracker: ORDER,
        is_subscription: 0,
        is_presence: 0,
        is_cleaner_ok: 0,
        is_contact_ok: 0,
        is_payed: 0,
        need_additional_services: null,
        note: null,
        address: null,
        foreman: null,
        cleaners: [],
        manual_price: null,
        is_manual_price: 0,
        revenue: 0,
        attachments_number: '',
      },
      attachments_number: '',
      attachmentsFiles: [],
      editableObject: {},
      pageLoading: false,
      dropOptions: {
        method: 'post',
        maxFilesize: 30, // MB
        maxFiles: 20,
        clickable: true,
        // acceptedFiles: '.png,.jpg,.jpeg,.mov',
        // chunking: true,
        // chunkSize: 500, // Bytes
        // thumbnailWidth: 150, // px
        // thumbnailHeight: 150,
        addRemoveLinks: true,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${localStorage.getItem('id_token')}`,
          Accept: 'application/json',
        },
        dictDefaultMessage: i18n.t('uploads.dictDefaultMessage'),
        dictFallbackMessage: i18n.t('uploads.dictFallbackMessage'),
        dictFallbackText: i18n.t('uploads.dictFallbackText'),
        dictFileTooBig: i18n.t('uploads.dictFileTooBig'),
        dictInvalidFileType: i18n.t('uploads.dictInvalidFileType'),
        dictResponseError: i18n.t('uploads.dictResponseError'),
        dictCancelUpload: i18n.t('uploads.dictCancelUpload'),
        dictCancelUploadConfirmation: i18n.t('uploads.dictCancelUploadConfirmation'),
        dictRemoveFile: i18n.t('uploads.dictRemoveFile'),
        dictMaxFilesExceeded: i18n.t('uploads.dictMaxFilesExceeded'),
      },
    };
  },
  created() {
    this.attachments_number = `temp_${  this.generateRandomString(25)}`;
  },
  mounted() {
    this.initEditableObject();
  },
  computed: {
    isCreation() {
      return !(this.item.uuid);
    },
    dialogTitle() {
      return this.isCreation ? this.item.name : '';
    },
    dateIso() {
      return this.editableObject.datetime ? moment(this.editableObject.datetime).toISOString() : null;
    },
    dropOptionsDefault() {
      const ob = Object.assign({}, this.dropOptions);
      ob.url = `${process.env.VUE_APP_API_LOCATION}/orders-complex/` + this.attachments_number + `/temp-attachments`;
      return ob;
    },
  },
  watch: {
    isShowDialog(newVal) {
      if (newVal) {
        this.attachments_number = 'temp_' + this.generateRandomString(25);
        this.attachmentsFiles.splice(0);
        this.initEditableObject();
        this.resetValidation();
      }
    },
    'editableObject.datetime': {
      handler(newVal) {
        if (newVal) {
          const a = moment(newVal);
          const b = moment().add(1, 'days').startOf('day');
          const diff = b.diff(a, 'days');
          if (diff === 0 || diff === 1) {
            this.editableObject.is_contact_ok = 1;
          }
        }
      },
    },
    'editableObject.address': {
      handler: function(newVal, oldVal) {
        if (newVal) {
          let old_uuid = oldVal instanceof Object && 'uuid' in oldVal ? oldVal.uuid : null;
          let new_uuid = newVal instanceof Object && 'uuid' in newVal ? newVal.uuid : null;
          if ('uuid' in newVal && old_uuid !== new_uuid) {
            this.isAddressHasOrders(newVal.uuid);
          }
        }
      },
      deep: true
    },
    'editableObject.is_manual_price': {
      handler(newVal) {
        this.editableObject.manual_price = newVal ? 0 : null;
      },
      deep: true
    },
  },
  methods: {
    initEditableObject() {
      const tmp = deepMerge(cloneObj(this.initialEditableObject), this.item);
      this.editableObject = tmp;
      setTimeout(() => {
        if (!sources || !Object.values(sources)
          .includes(this.editableObject.source)) {
          this.editableObject.source = sources.UNSET;
        }
      }, 0);
      this.editableObject.attachments_number = this.attachments_number;
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    onAction() {
      if (this.isValidForm()) {
        this.$emit('on-action', this.editableObject);
      }
    },
    isValidForm() {
      this.addressError = !(this.editableObject.address);
      return this.$refs.form.validate() && !this.addressError;
    },
    isAddressHasOrders(uuid) {
      this.pageLoading = true;
      new AddressProxy()
        .getAddressWithOrders(uuid)
        .then(response => {
          if (response.data.data.address.orders.orders_done > 0 && sources) {
            this.editableObject.source = sources.CLIENT;
          }
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    generateRandomString(length) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    afterComplete(file, response) {
      this.$refs.dropzone.removeFile(file);
    },
    onFileError(file, response) {
      const errors = prepareValidationMessages(response.data);
      if (errors.file) {
        this.$store.dispatch('page/displaySnackbar', {
          text: errors.file,
          color: 'red darken-3',
          timeout: 6000,
        });
      }
    },
    onFileUploaded(file, response) {
      if (response && 'data' in response && 'file' in response.data) {
        this.attachmentsFiles.push({
          id: response.data.file.id,
          link: response.data.file.link
        });
      }
    },
    isImage(url) {
      return (url.match(/\.(jpeg|jpg|gif|png)$/) != null);
    },
    deleteFile(fileId) {
      const searchIndex = this.attachmentsFiles.findIndex((attachment) => attachment.id === fileId);
      if (searchIndex === -1) {
        return;
      }

      this.pageLoading = true;
      new OrderComplexProxy().deleteTempAttachment(fileId)
        .then(response => {
          this.attachmentsFiles.splice(searchIndex, 1);
        })
        .catch(error => {
          console.error(error);
          return this.$router.push({
            name: 404,
          });
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.preview-attachment {
  background-color: #66a0f7;
  width: 100%;
  position: relative; /* If you want text inside of it */
  margin-bottom: 20px;
  max-width: 85px;
  &__content {
    display: block;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    text-decoration: none;

    img {
      display: block;
      width: 100%;
      max-height: 100px;
      object-fit: cover;
    }

    .text {
      display: flex;
      width: 100%;
      height: 100%;
      color: white;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      font-size: 1em;
      text-decoration: none;
    }
  }
}
</style>
